export default __webpack_public_path__ + "static/media/room-8.5b658df9.jpg";